{
    "version": 1,
    "themeName": "osano",
    "theme": {
        "seriesCnt": "8",
        "backgroundColor": "rgba(0, 0, 0, 0)",
        "titleColor": "#180d43",
        "subtitleColor": "#90a4ae",
        "textColorShow": false,
        "textColor": "#333",
        "markTextColor": "#eee",
        "color": [
            "#480091",
            "#6db6ff",
            "#b66dff",
            "#b5dafe",
            "#fe6db6",
            "#feb5da",
            "#AA4499",
            "#074650",
            "#009292"
        ],
        "borderColor": "#ccc",
        "borderWidth": 0,
        "visualMapColor": ["#480091", "#be7efe", "#ebd7fe"],
        "legendTextColor": "#180d43",
        "kColor": "#f44336",
        "kColor0": "#37cd84",
        "kBorderColor": "#f44336",
        "kBorderColor0": "#37cd84",
        "kBorderWidth": 1,
        "lineWidth": 2,
        "symbolSize": 4,
        "symbol": "emptyCircle",
        "symbolBorderWidth": 1,
        "lineSmooth": false,
        "graphLineWidth": 1,
        "graphLineColor": "#aaa",
        "mapLabelColor": "#000",
        "mapLabelColorE": "rgb(100,0,0)",
        "mapBorderColor": "#444",
        "mapBorderColorE": "#444",
        "mapBorderWidth": 0.5,
        "mapBorderWidthE": 1,
        "mapAreaColor": "#eee",
        "mapAreaColorE": "rgba(255,215,0,0.8)",
        "axes": [
            {
                "type": "all",
                "name": "Universal Axes",
                "axisLineShow": true,
                "axisLineColor": "#6E7079",
                "axisTickShow": true,
                "axisTickColor": "#6E7079",
                "axisLabelShow": true,
                "axisLabelColor": "#6E7079",
                "splitLineShow": true,
                "splitLineColor": ["#E0E6F1"],
                "splitAreaShow": false,
                "splitAreaColor": ["rgba(250,250,250,0.2)", "rgba(210,219,238,0.2)"]
            },
            {
                "type": "category",
                "name": "Category",
                "axisLineShow": true,
                "axisLineColor": "#6E7079",
                "axisTickShow": true,
                "axisTickColor": "#6E7079",
                "axisLabelShow": true,
                "axisLabelColor": "#6E7079",
                "splitLineShow": false,
                "splitLineColor": ["#E0E6F1"],
                "splitAreaShow": false,
                "splitAreaColor": ["rgba(250,250,250,0.2)", "rgba(210,219,238,0.2)"]
            },
            {
                "type": "value",
                "name": "Numeric",
                "axisLineShow": false,
                "axisLineColor": "#6E7079",
                "axisTickShow": false,
                "axisTickColor": "#6E7079",
                "axisLabelShow": true,
                "axisLabelColor": "#6E7079",
                "splitLineShow": true,
                "splitLineColor": ["#E0E6F1"],
                "splitAreaShow": false,
                "splitAreaColor": ["rgba(250,250,250,0.2)", "rgba(210,219,238,0.2)"]
            },
            {
                "type": "log",
                "name": "Logarithmic",
                "axisLineShow": false,
                "axisLineColor": "#6E7079",
                "axisTickShow": false,
                "axisTickColor": "#6E7079",
                "axisLabelShow": true,
                "axisLabelColor": "#6E7079",
                "splitLineShow": true,
                "splitLineColor": ["#E0E6F1"],
                "splitAreaShow": false,
                "splitAreaColor": ["rgba(250,250,250,0.2)", "rgba(210,219,238,0.2)"]
            },
            {
                "type": "time",
                "name": "Time",
                "axisLineShow": true,
                "axisLineColor": "#6E7079",
                "axisTickShow": true,
                "axisTickColor": "#6E7079",
                "axisLabelShow": true,
                "axisLabelColor": "#6E7079",
                "splitLineShow": false,
                "splitLineColor": ["#E0E6F1"],
                "splitAreaShow": false,
                "splitAreaColor": ["rgba(250,250,250,0.2)", "rgba(210,219,238,0.2)"]
            }
        ],
        "axisSeperateSetting": true,
        "toolboxColor": "#999",
        "toolboxEmphasisColor": "#666",
        "tooltipAxisColor": "#ccc",
        "tooltipAxisWidth": 1,
        "timelineLineColor": "#DAE1F5",
        "timelineLineWidth": 2,
        "timelineItemColor": "#A4B1D7",
        "timelineItemColorE": "#FFF",
        "timelineCheckColor": "#316bf3",
        "timelineCheckBorderColor": "fff",
        "timelineItemBorderWidth": 1,
        "timelineControlColor": "#A4B1D7",
        "timelineControlBorderColor": "#A4B1D7",
        "timelineControlBorderWidth": 1,
        "timelineLabelColor": "#A4B1D7"
    }
}
